/**
 * This file contains utility functions for working with environment variables.
 */

/**
 * Parse a boolean value from an environment variable.
 * @param envValue The environment variable value
 * @returns true if the value is "true", false otherwise
 */
export function parseBoolean(envValue: string | undefined): boolean {
  return envValue === "true";
}
